<div class="container mb-4">
    <div class="row">
        <div class="col-md-6" *ngFor="let menu of menucategories">
            <div class="card">
                <div class="avatar" [ngStyle]="{'background-image':'url('+(menu.avatar|absolutePath:'families')+')'}">
                </div>
                <div class="infos">
                    <div class="name">
                        {{menu.name|uppercase}}
                    </div>
                    <div class="price">
                        <i class="fa fa-tag" aria-hidden="true"></i>
                        <ng-container *ngIf="menu.price">
                            À partir de <span>{{menu.price}} €</span>
                        </ng-container>
                        <ng-container *ngIf="!menu.price">
                            <span>Offre</span>
                        </ng-container>
                    </div>
                    <a class="btn btn-block btn-danger align-items-center d-flex btn-sm mr-2"
                        routerLink="/carte/menus/{{menu.slug}}">
                        <img class="mr-2" width="25px" src="assets/images/addBasket.png" alt="commander">
                        <span>Commander</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-md-6" *ngFor="let family of families">
            <div class="card">
                <div class="avatar" [ngStyle]="{'background-image':'url('+(family.avatar|absolutePath:'families')+')'}">
                </div>
                <div class="infos">
                    <div class="name">
                        {{family.label|uppercase}}
                    </div>
                    <div class="price">
                        <i class="fa fa-tag" aria-hidden="true"></i>
                        À partir de <span>{{family.price}} €</span>
                    </div>
                    <a class="btn btn-block btn-danger align-items-center d-flex btn-sm mr-2"
                        routerLink="/carte/famille/{{family.slug}}">
                        <img class="mr-2" width="25px" src="assets/images/addBasket.png" alt="commander">
                        <span>Commander</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>